var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8909 4.33073C6.95291 5.34375 4.04315 8.91724 4.04315 13.1729V19.2591C4.04315 19.8199 3.58746 20.2745 3.02982 20.2745C1.90857 20.2745 1 21.1853 1 22.3033C1 23.4238 1.91 24.3323 3.03369 24.3323H23.3127C24.436 24.3323 25.3464 23.4216 25.3464 22.3033C25.3464 21.1827 24.4336 20.2745 23.3166 20.2745C22.7569 20.2745 22.3032 19.8234 22.3032 19.2591V13.1729C22.3032 8.91859 19.3942 5.34401 15.4555 4.33073V3.28279C15.4555 2.01898 14.4337 1 13.1731 1C11.9149 1 10.8907 2.02214 10.8907 3.28279L10.8909 4.33073ZM9.6228 25.347H16.7238C16.7238 27.3078 15.1341 28.8975 13.1733 28.8975C11.2125 28.8975 9.6228 27.3078 9.6228 25.347Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.70dcb1243d82b13fdd91a4f875abdeb7.svg";
export { ForwardRef as ReactComponent };